import { conflitoLabel } from "@/modules/carga-trabalho";

import type {
  GanttFornecedorNomeProps,
  GanttFornecedorNomeViewModel,
} from "./types-gantt-fornecedor-nome";

export function useGanttFornecedorNome(
  props: GanttFornecedorNomeProps,
): GanttFornecedorNomeViewModel {
  const { conflicts } = props.row;

  return { ...props, rotuloConflito: conflicts > 0 ? conflitoLabel(conflicts) : null };
}
